<ng-container>

    @if (!toggled) {
        <img (click)="onAudioClicked($event)" [src]="playIcon" alt="Audio abspielen" class="player-icon"/>
    }
    @if (toggled) {
        <img (click)="onAudioClicked($event)" [src]="pauseIcon" alt="Audio pausieren" class="player-icon"/>
    }

    @if (audio.url) {
        <audio #audioPlayer
               (canplay)="onCanPlay()"
               (ended)="onEnd()"
               [attr.type]="audio.audioFile.mimeType"
               class="grow"
               src="{{audio.url}}">
            Your browser does not support the audio element.
        </audio>
    }

</ng-container>